import { useNavigate } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import { IconArrowBack } from '../../ui/styled';

const BackIcon = ({level = -1}) => {
  const navigate = useNavigate();
  return (
    <IconButton onClick={() => navigate(level)}>
      <IconArrowBack />
    </IconButton>
  );
};

export default BackIcon;
